import { PropertyInfoState } from 'appRedux/reducers/setup/propertyInfo'
import { useSelector } from 'react-redux'
import { AppState } from 'ReducerState'

const PropertyInfoStateHook = () => {

    const propertyInfo: PropertyInfoState = useSelector((state: AppState) => state.propertyInfo)
    const { loader, dataSource, process } = propertyInfo

    return {
        loader,
        dataSource,
        process
    }
}

export default PropertyInfoStateHook